'use client';
import { Input, useToast } from '@ethsign/ui';
import { shortenWalletAddress } from '@ethsign/utils-web';
import { forwardRef, useEffect, useState } from 'react';

import { cn } from '@/lib/utils';

import { getEnsAddress } from '@/utils';
interface EnsInputProps {
  value?: string;
  onChange?: (v: string) => void;
  network?: string;
  placeholder: string;
  disabled?: boolean;
  className?: string;
  inputClassName?: string;
}

export const EnsInput = forwardRef<HTMLInputElement, EnsInputProps>(
  ({ value, onChange, placeholder, disabled, className, inputClassName }, ref) => {
    const [options, setOptions] = useState<string[]>([]);
    const { toast } = useToast();
    const getEns = async (value: string) => {
      const ens = await getEnsAddress(value);
      console.log(ens);
      if (ens) {
        setOptions([ens]);
      } else {
        toast({
          title: 'not found',
          variant: 'error',
          description: 'Can not find any address for the entered ENS name.'
        });
      }
    };
    useEffect(() => {
      console.log(value);
      if (value && value?.endsWith('.eth')) {
        getEns(value);
      }
      if (!value && options?.length) {
        setOptions([]);
      }
    }, [value]);
    return (
      <div className={cn('relative', className)}>
        <Input
          className={cn('min-h-[64px]', inputClassName)}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          ref={ref}
          disabled={disabled}
        />
        {options?.length ? (
          <div
            className={
              'absolute top-[66px] left-0 z-50 w-full overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md animate-in fade-in-80'
            }
          >
            {options.map((v, i) => (
              <div
                key={i}
                onClick={() => {
                  onChange?.(v);
                  setOptions([]);
                }}
                className={
                  'relative flex w-full cursor-pointer items-center rounded-sm py-2 px-2 text-sm text-gray-900 outline-none focus:bg-accent hover:bg-gray-50 focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50'
                }
              >
                <span title={v}>{shortenWalletAddress(v, 'shorter')}</span>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    );
  }
);

EnsInput.displayName = 'EnsInput';
